import type { Campaign } from './campaignsApi';
import { campaignChannels } from './campaignChannels';

export type CampaignStatusTone = 'draft' | 'review' | 'ready' | 'paused' | 'active' | 'completed' | 'archived' | 'error';
const statuses: Record<string, { label: string; tone: CampaignStatusTone }> = {
  draft: { label: 'Rascunho', tone: 'draft' }, rascunho: { label: 'Rascunho', tone: 'draft' },
  briefing: { label: 'Briefing', tone: 'draft' }, planejada: { label: 'Planejada', tone: 'draft' },
  backlog: { label: 'Rascunho', tone: 'draft' }, legado: { label: 'Legado', tone: 'draft' },
  em_revisao: { label: 'Em revisão', tone: 'review' }, review: { label: 'Em revisão', tone: 'review' },
  validacao: { label: 'Em validação', tone: 'review' },
  pronta_publicacao: { label: 'Pronta para publicar', tone: 'ready' },
  scheduled: { label: 'Agendada', tone: 'ready' }, publicando: { label: 'Publicando', tone: 'ready' },
  publishing: { label: 'Publicando', tone: 'ready' }, publicada: { label: 'Publicada', tone: 'ready' },
  ativa: { label: 'Ativa', tone: 'active' }, active: { label: 'Ativa', tone: 'active' },
  enabled: { label: 'Ativa', tone: 'active' }, running: { label: 'Ativa', tone: 'active' },
  otimizando: { label: 'Otimizando', tone: 'active' },
  pausada: { label: 'Pausada', tone: 'paused' }, paused: { label: 'Pausada', tone: 'paused' },
  concluida: { label: 'Concluída', tone: 'completed' }, completed: { label: 'Concluída', tone: 'completed' },
  arquivada: { label: 'Arquivada', tone: 'archived' }, archived: { label: 'Arquivada', tone: 'archived' },
  deleted: { label: 'Excluída', tone: 'archived' }, removed: { label: 'Removida', tone: 'archived' },
  erro: { label: 'Erro', tone: 'error' }, error: { label: 'Erro', tone: 'error' },
  failed: { label: 'Falha', tone: 'error' }, bloqueada: { label: 'Bloqueada', tone: 'error' },
};

export function campaignStatusStyle(status: string) {
  return statuses[status.toLowerCase()] || { label: status || 'Não informado', tone: 'draft' as const };
}

export function campaignChannelStatus(campaign: Campaign, channel: 'meta' | 'google') {
  const meta = channel === 'meta';
  const id = meta ? campaign.meta_campaign_id : campaign.google_campaign_id;
  const status = meta ? campaign.meta_confirmed_status : campaign.google_confirmed_status;
  const sync = meta ? campaign.meta_sync_status : campaign.google_sync_status;
  const error = meta ? campaign.meta_last_error : campaign.google_last_error;
  const checkError = meta ? campaign.meta_status_check_error : campaign.google_status_check_error;
  const checkedAt = meta ? campaign.meta_status_checked_at : campaign.google_status_checked_at;
  if (!id) return { label: 'Sem vínculo', tone: 'draft' as const };
  if (checkError) return { label: 'Falha na consulta', tone: 'error' as const };
  if (['syncing', 'pending', 'status_changing', 'publishing'].includes(sync || '')) {
    return { label: 'Sincronizando', tone: 'ready' as const };
  }
  if (status && checkedAt) return campaignStatusStyle(status);
  if (error || sync === 'error') return { label: status ? `${campaignStatusStyle(status).label} · erro de sincronização` : 'Erro de sincronização', tone: 'error' as const };
  return status ? campaignStatusStyle(status) : { label: 'Status não confirmado', tone: 'draft' as const };
}

export function campaignStatusPresentation(campaign: Campaign) {
  const style = campaignStatusStyle(campaign.status);
  if (style.tone !== 'active' || campaign.campaign_type === 'whatsapp_blast') return style;
  const confirmed = campaignChannels(campaign).every(channel => campaignChannelStatus(campaign, channel).tone === 'active');
  return confirmed ? style : { label: `${style.label} · status local`, tone: 'draft' as const };
}
